import React from "react";
import { default as Dashboard2 } from "../ListItems/Dashboard";

export { default as ContactsModule } from "./ContactsModule";
export { default as DevicesModule } from "./DevicesModule";
export { default as LifeCycleModule } from "./LifeCycleModule";
export { default as MaintenanceModule } from "./MaintenanceModule";
export { default as OrdersModule } from "./OrdersModule";
export { default as ResupplysModule } from "./ResupplysModule";
export { default as ShipmentsModule } from "./ShipmentsModule";
export { default as ServiceItemModule } from "./ServiceItemModule";
export { default as SoftwareModule } from "./SoftwareModule";
export { default as ManufacturingModule } from "./ManufacturingModule";
export { default as StockModule } from "./StockModule";
export { default as SystemModule } from "./SystemModule";
export { default as WebstoreModule } from "./WebstoreModule";

export const Dashboard = () => {
  return <Dashboard2 link={"/cpanel"} />;
};
